<script setup lang="ts">
export interface IconAdd {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  backgroundFill?: string;
  class?: string;
}

const props = withDefaults(defineProps<IconAdd>(), {
  width: 56,
  height: 56,
  fill: "#7D899B",
  stroke: "#DFDFDF",
  backgroundFill: "#EEEEEE",
});
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :class="props.class"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="55"
      height="55"
      rx="27.5"
      :fill="props.backgroundFill"
    />
    <rect
      x="0.5"
      y="0.5"
      width="55"
      height="55"
      rx="27.5"
      :stroke="props.stroke"
    />
    <path
      d="M29.168 22V26.5H33.668V29.5H29.168V34H26.168V29.5H21.668V26.5H26.168V22H29.168Z"
      :fill="props.fill"
    />
  </svg>
</template>
